import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const ChooseeCommerce: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary fw-400">
                Success in the world of e-commerce isn&apos;t just about selling
                products; it&apos;s about empowering your brand to thrive in the
                digital era. E-commerce app development serves as the gateway to
                reach a wider audience, enhance user experiences, and boost
                revenue. Transform your vision into a functional, user-friendly
                e-commerce solution to thrive in the competitive world of online
                commerce.
              </p>

              <p className="fs-md text-secondary fw-400">
                Moweb is a trusted leader in the realm of e-commerce development
                services with a rich portfolio of successful e-commerce
                projects. Our e-commerce expertise extends across a wide range
                of e-commerce technologies, ensuring we can deliver exceptional
                results for your business. From front-end web design to back-end
                development and everything in between, we have the skills and
                knowledge to harness the power of technology for your success.
              </p>

              <p className="fs-md text-secondary mb-0 fw-400">
                Our e-commerce web developers leverage a wide array of tools and
                technologies to effectively oversee their digital operations,
                enrich the overall shopping experience for customers, and
                ultimately, stimulate and increase sales. We specialize in
                e-commerce tools and technologies essential for running a
                successful business like,
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-9">
            <div className="row grid grid-cols-2">
              <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                <KEYBlue text="E-commerce Platforms (e.g., Shopify, WooCommerce, Magento, etc)" />
                <KEYBlue text="Payment Gateways (e.g., PayPal, Stripe)" />
                <KEYBlue text="Inventory Management (e.g., TradeGecko)" />
                <KEYBlue text="CRM (e.g., Salesforce, HubSpot)" />
                <KEYBlue text="Email Marketing (e.g., Mailchimp)" />
                <KEYBlue text="Analytics (e.g., Google Analytics)" />
                <KEYBlue text="SEO Tools (e.g., Moz, SEMrush)" />
                <KEYBlue text="Social Media Management (e.g., Hootsuite)" />
                <KEYBlue text="Customer Support (e.g., Zendesk)" />
                <KEYBlue text="Security (e.g., SSL Certificates)" />
              </div>
              <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                <KEYBlue text="Shipping Solutions (e.g., ShipStation)" />
                <KEYBlue text="PIM (e.g., Akeneo)" />
                <KEYBlue text="Mobile Commerce (e.g., Progress Web Application)" />
                <KEYBlue text="AI/ML (e.g., Personalization" />
                <KEYBlue text="AR/VR (e.g., AR Visualization)" />
                <KEYBlue text="Voice Commerce (e.g., Voice Assistants)" />
                <KEYBlue text="Marketplace Platforms (e.g., Amazon)" />
                <KEYBlue text="Subscription Management (e.g., Recurly)" />
                <KEYBlue text="Cross-border Tools (e.g., Currency Conversion)" />
                <KEYBlue text="Mobile-responsive Design" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ChooseeCommerce
